/** Query param used on `/` to scroll to an embedded dashboard panel. */
export const DASHBOARD_PANEL_QUERY = 'panel';
/** When set to `kanban` with `panel=library`, Content Library shows the review Kanban. */
export const LIBRARY_VIEW_QUERY = 'libraryView';
export const LIBRARY_VIEW_KANBAN = 'kanban';
export function dashboardPanelHref(panel, hash) {
    const h = hash && hash.length > 0 ? `#${hash.replace(/^#/, '')}` : '';
    if (panel === 'reviews') {
        const base = `/?${DASHBOARD_PANEL_QUERY}=library&${LIBRARY_VIEW_QUERY}=${LIBRARY_VIEW_KANBAN}`;
        return `${base}${h}`;
    }
    const base = `/?${DASHBOARD_PANEL_QUERY}=${panel}`;
    return `${base}${h}`;
}
/** True when the dashboard URL should show the embedded review Kanban inside Content Library. */
export function isDashboardLibraryKanbanView(params) {
    const panel = params.get(DASHBOARD_PANEL_QUERY);
    const lv = params.get(LIBRARY_VIEW_QUERY);
    return lv === LIBRARY_VIEW_KANBAN || panel === 'reviews';
}
